/**
 * If enabled, a retailer who has only placed a FD order will be eligible for an evergreen marketplace * discount. PRD: https:www.notion.so/faire/Evergreen-Marketplace-Discount-da0bb2f01b5d4baeb75fd67d12c5a957
 */
export const FAIRE_DIRECT_EVERGREEN_MARKETPLACE_DISCOUNT_240506 = 'FAIRE_DIRECT_EVERGREEN_MARKETPLACE_DISCOUNT_240506';
